import React from "react";
import { Box, Flex } from "theme-ui";
import P from "components/typography/P";
import ActionRequiredBanner from "./ActionRequiredBanner";
import KPICards from "./KPICards";
import RecentActivityFeed from "./RecentActivityFeed";
import ActionItems from "./ActionItems";
import CalendarView from "./CalendarView";

const ManagerDashboard: React.FC = () => {
  return (
    <Box>
      {/* Action Required Alert Banner */}
      <ActionRequiredBanner dashboardType="manager" />

      {/* Recent Activity and Action Items - Top Row */}
      <Flex sx={{ gap: "16px", flexWrap: "wrap", marginBottom: "24px" }}>
        <RecentActivityFeed />
        <ActionItems />
      </Flex>

      {/* Calendar View - Middle */}
      <Box sx={{ marginBottom: "24px" }}>
        <CalendarView role="manager" />
      </Box>

      {/* KPI Cards - Bottom */}
      <KPICards />
    </Box>
  );
};

export default ManagerDashboard;
